import React from 'react';
import { Router } from './Router';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import { ModalsProvider } from '@mantine/modals';
import { RefererProvider } from './providers/RefererProvider';
import { ChromeSmartAppBanner } from './components/ChromeSmartAppBanner';

import './App.css';

function App() {

  return (
    <>
    <MantineProvider >
      <ModalsProvider>
        <RefererProvider>
          <ChromeSmartAppBanner />
          <div id="main-body" style={{color: "#03034F"}}>
            <Router />
          </div>
        </RefererProvider>
      </ModalsProvider>
    </MantineProvider>
    </>
  )
}
export default App;
